<template>
  <div class="acsidebar shadow-lg" v-show="sidebarloaded===true">
    <div class="text-center sidebarpl" v-show="sidebarenabled===false">
      <p><button @click="doUnCollapse" class="btn-transparent"><font-awesome-icon icon="bars" aria-label="Expand Sidebar"></font-awesome-icon></button></p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p><router-link :to="{name: 'orgpools', params: { id: org.OrganizationID }}"><font-awesome-icon icon="object-group" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'orgedit', params: { id: org.OrganizationID }}"><font-awesome-icon icon="edit" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'orgprivs', params: { id: org.OrganizationID }}"><font-awesome-icon icon="user-lock" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'orgtransfer', params: { id: org.OrganizationID }}"><font-awesome-icon icon="angle-double-right" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'orgorderhistory', params: { id: org.OrganizationID }}"><font-awesome-icon icon="cart-arrow-down" role="presentation"></font-awesome-icon></router-link></p>
      <p><router-link :to="{name: 'orgreporting', params: { id: org.OrganizationID }}"><font-awesome-icon icon="chart-pie" role="presentation"></font-awesome-icon></router-link></p>
    </div>
    <div v-show="sidebarenabled===true" class="sidebarpl">
      <button @click="doCollapse" class="btn-transparent" style="margin-left:-15%"><font-awesome-icon icon="bars" aria-label="Collapse Sidebar"></font-awesome-icon></button>
      <h3>{{org.OrganizationName}} </h3>
      <div class="accountstatus" id="account_status">{{acctStatus}}</div>
      <div class="sidebarlinks" v-if="org!==null">
        <p><router-link :to="{name: 'orgpools', params: { id: org.OrganizationID }}"><font-awesome-icon icon="object-group" role="presentation"></font-awesome-icon> Pools</router-link></p>
        <p><router-link :to="{name: 'orgedit', params: { id: org.OrganizationID }}"><font-awesome-icon icon="edit" role="presentation"></font-awesome-icon> Edit</router-link></p>
        <p><router-link :to="{name: 'orgprivs', params: { id: org.OrganizationID }}"><font-awesome-icon icon="user-lock" role="presentation"></font-awesome-icon> Privileges</router-link></p>
        <p><router-link :to="{name: 'orgtransfer', params: { id: org.OrganizationID }}"><font-awesome-icon icon="angle-double-right" role="presentation"></font-awesome-icon> Transfer Licenses</router-link></p>
        <p><router-link :to="{name: 'orgorderhistory', params: { id: org.OrganizationID }}"><font-awesome-icon icon="cart-arrow-down" role="presentation"></font-awesome-icon> Order History</router-link></p>
        <p><router-link :to="{name: 'orgreporting', params: { id: org.OrganizationID }}"><font-awesome-icon icon="chart-pie" role="presentation"></font-awesome-icon> Reporting</router-link></p>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .accountstatus {
     margin-top:5%;
  }
</style>

<script>
  export default {
     name: 'OrgSidebar',
     data() {
       return {
         acctStatus:"Normal Account",
         org: {
           OrganizationName: "Loading",
           OrganizationID: this.emptyguid
         },
         sidebarenabled: null,
         sidebarloaded: false
       }
     },
    methods: {
      doCollapse() {
        this.sidebarenabled=false;
        this.collapseSidebar();
      },
      doUnCollapse() {
        this.sidebarenabled=true;
        this.deCollapseSidebar();
      }
     },
     mounted() {
       
       this.$bus.$on("OrgSidebarUpdateEvent", (ispro, ao, isenabled) => {
           if (ispro) {
             this.acctStatus="Pro Account";
           }
           this.org=ao;

        
           if (typeof(isenabled)!=="undefined" && isenabled===false) {
             this.sidebarenabled=false;
             var self=this;
             window.setTimeout(function() {
               self.collapseSidebar();
               self.sidebarloaded=true;
             },100);
           }
           else {
             this.sidebarloaded=true;
             this.sidebarenabled=true;
           }
       });

       setTimeout("Window.loadLanguageContent()", 500);
     }
  }
</script>
